import React from 'react';
import PageMenu from '../../components/PageMenu';

function MenuProduct() {
  return (
    <PageMenu
      title="Find Your Home Menu"
      items={[
        {
          name: 'communities',
          title: 'New Home Communities',
          keepParams: true,
        },
        {
          name: 'homes',
          title: 'Quick Move-In Homes',
          keepParams: true,
        },
        {
          name: 'plans',
          title: 'Available Floor Plans',
          keepParams: true,
        },
        {
          id: '#area-info',
          title: 'Area Info',
        },
      ]}
    />
  );
}

export default MenuProduct;



// WEBPACK FOOTER //
// ./src/components/MenuProduct/index.js